<template>
  <section class="promotions">
    <div class="promotions__container">
      <h1 class="promotions__title">{{ category.getName() }}</h1>
      <div class="promotions__content">
        <Promotion
          v-for="promotionCategory in promotionCategories()"
          :key="promotionCategory.id"
          :category="promotionCategory"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import Promotion from "~/modules/productCatalog/ui/pages/promotions/Promotion.vue";
import { useCategoriesStore } from "~~/store/categoriesStore";
import { Category } from "~/models/category.model";

const props = defineProps({
  category: { type: Category, required: true },
});

const categoryStore = useCategoriesStore();
const { getChildren: children } = storeToRefs(categoryStore);

const promotionCategories = () => {
  const filteredChildren = children
    .value(props.category)
    .filter((category) => null !== category.promotion);

  return filteredChildren.sort(
    (a, b) => b.promotion.period.endAt - a.promotion.period.endAt,
  );
};
</script>

<style lang="scss" scoped>
.promotions {
  padding: 0 16px;
  margin-bottom: 32px;

  &__container {
    @extend %width-main;
    margin: auto;
  }

  &__title {
    @include font(36, 43, 700);
    letter-spacing: 0.36px;
    padding-bottom: 24px;

    @include bigMobile {
      @include font(28, 38, 700);
      letter-spacing: 0.48px;
    }

    @include mobile {
      @include font(24, 34, 700);
      letter-spacing: 0.48px;
      padding-bottom: 16px;
    }
  }

  &__content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(315px, 1fr));
    gap: 8px;

    @include mobile {
      gap: 16px;
    }
  }
}
</style>
